import { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type Separator = [string, string];

//TODO: Add this to a config file.
// DEFINE NOTATION HERE:
const separatorToClass: Separator[] = [
  ["§1", "bg-gradient-to-r from-gradient-start to-gradient-end bg-clip-text text-transparent"],
  ["§2", "bg-gradient-to-r from-gradient-end to-gradient-start bg-clip-text text-transparent"],
  ["*", "font-semibold"],
  ["_", "italic"],
  ["¶", "font-bold"],
  ["@", "newline"],
];

// TODO: Handle errors.
function processText(text: string, overwritingClassName: string): ReactNode {
  // convert string into array of [[string, classes], string, ...] for strings with and without notation
  const tokenize = (str: string): (string | [string, string])[] => {
    let tokens: (string | [string, string])[] = [str];

    for (const [separator, className] of separatorToClass) {
      // Flatten the array to prevent nesting caused by parts.map
      tokens = tokens.flatMap(token => {
        if (typeof token !== 'string') return [token];

        // split string into parts for each notation. Ex: §Hello§ world -> ["§Hello§","world"]
        const parts = token.split(new RegExp(`(\\${separator}.*?\\${separator})`, 's'));
        // result: [part, [part, className], ...]
        return parts.map(part =>
          // extract string from notation & match with corresponding className
          part.startsWith(separator) && part.endsWith(separator)
            ? [part.slice(separator.length, -separator.length), className]
            // no notation found, just return string
            : part
        );
      });
    }

    return tokens;
  };

  // Recursively traverse through different layers of notation and construct JSX
  const renderTokens = (tokens: (string | [string, string])[]): ReactNode[] => {
    return tokens.map((token, index) => {
      if (typeof token === 'string') return token;
      const [content, className] = token;
      if (className === "newline") return <p key={index}>{renderTokens(tokenize(content))}</p>
      return (
        <span key={index} className={twMerge(className, overwritingClassName)}>
          {renderTokens(tokenize(content))}
        </span>
      );
    });
  };

  return <>{renderTokens(tokenize(text))}</>;
}


interface TextProcessorProps {
  children: string;
  className?: string;
}

export default function TextProcessor({ children, className = '' }: TextProcessorProps): ReactNode {

  return processText(children, className);
}
